import React from 'react';
import { Button } from '@/components/ui/button';
import { formatSpeed } from '@/utils/audioUtils';

interface SpeedPresetButtonsProps {
  currentRate: number;
  onRateChange: (rate: number) => void;
}

const SPEED_PRESETS = [0.5, 0.75, 1.0, 1.25, 1.5, 2.0];

export const SpeedPresetButtons: React.FC<SpeedPresetButtonsProps> = ({
  currentRate,
  onRateChange,
}) => {
  const isActive = (speed: number) => {
    return Math.abs(currentRate - speed) < 0.05;
  };

  return (
    <div className="flex flex-wrap gap-2">
      {SPEED_PRESETS.map((speed) => (
        <Button
          key={speed}
          size="sm"
          variant={isActive(speed) ? 'default' : 'outline'}
          onClick={() => onRateChange(speed)}
          className={`min-w-[60px] transition-all ${
            isActive(speed)
              ? 'bg-primary text-primary-foreground shadow-md'
              : 'hover:bg-secondary'
          }`}
          aria-label={`Set speed to ${formatSpeed(speed)}`}
        >
          {formatSpeed(speed)}
        </Button>
      ))}
    </div>
  );
};
